"use client";
import useCountDown from "@/hooks/useCountdown";
import { useRouter } from "@/i18n/routing";
import { getToken } from "@/utils/Cookies";
import { Mask } from "antd-mobile";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { FC, forwardRef, memo, useImperativeHandle, useRef, useState } from "react";

interface Props {}

export interface ModalRefProps {
    onClose?: () => void;
    onOpen?: (data: any, index: number) => void;
}

export interface RechargeContentProps {
    onCancel?: () => void;
    recharge?: any;
    type?: "page" | "popup";
}

export function Timeout(props: { endTime: number; className?: string; onEndHandler?: () => void }) {
    const { endTime, className, onEndHandler } = props;
    const [countdown, time] = useCountDown({
        leftTime: endTime * 1000,
        onEnd: () => {
            onEndHandler && onEndHandler();
        },
    });
    const cls = clsx(
        className ? className : "w-full mb-[0.0694rem] text-center text-[0.1528rem] font-bold"
    );

    const countdownText = `${time.days > 0 ? (time.days + "d").padStart(2, "0") : ""}`;
    return (
        <div className={cls}>
            {countdownText}
            {`${time.hours}`.padStart(2, "0")}h{`${time.minutes}`.padStart(2, "0")}m
            {`${time.seconds}`.padStart(2, "0")}s
        </div>
    );
}
export const RechargeContent: FC<RechargeContentProps> = (props) => {
    const { onCancel, type = "popup", recharge } = props;
    const t = useTranslations("HomePage");
    const token = getToken();
    const router = useRouter();

    const receiveHandler = () => {
        if (token) {
            router.push("/deposit");
        } else {
            router.push("/login?redirect=deposit");
        }
        onCancel && onCancel();
    };
    const colors: any = {
        1: "from-[#d93b1a] to-[#ff9a1f]",
        2: "from-[#29f19c] to-[#02a1f9]",
        3: "from-[#12d6df] to-[#f70fff]",
        4: "from-[#0dccff] to-[#4760ff]",
    };
    const text: any = {
        1: "st",
        2: "nd",
        3: "rd",
        4: "th",
    };
    return (
        <div className={""}>
            <div className={"relative mt-[18%]"}>
                {type === "popup" ? (
                    <div
                        onClick={onCancel}
                        className={
                            "absolute right-[10%] top-0 h-[0.1736rem] w-[0.1736rem]" +
                            " rounded-[50%] border-[2px] border-[#dcd8bb] text-[#dcd8bb]" +
                            " flex items-center justify-center"
                        }
                    >
                        <span className={"iconfont icon-guanbi text-[0.0972rem]"}></span>
                    </div>
                ) : null}

                <div className={"absolute -top-[0.34rem] left-0 -z-10 h-[100%] w-[100%]"}>
                    <img src={"/recharge/bg.webp"} className={"h-[100%] w-[100%]"} />
                </div>
                <div
                    className={"absolute left-0 top-0 -z-[9] h-[100%] w-[100%] animate-slow-bounce"}
                >
                    <img src={"/recharge/bg1.webp"} className={"h-[100%] w-[100%]"} />
                </div>
                <div className="px-[.15rem]">
                    <Image
                        src={"/recharge/content.webp"}
                        alt={"recharge"}
                        className={"z-2 w-[100%]"}
                        width={720}
                        height={300}
                    />
                </div>
            </div>
            {/*倒计时*/}
            {recharge && recharge.count_down !== 0 ? (
                <Timeout endTime={recharge.count_down} />
            ) : null}

            <div
                className={
                    "grid grid-cols-2 justify-center gap-[0.1389rem] px-[.3rem] py-[0.1389rem]"
                }
            >
                {recharge?.condition.map((item: any, index: number) => {
                    // @ts-ignore
                    return (
                        <div key={index} className={"relative justify-self-center"}>
                            <Image
                                src={`/recharge/leve-wrap${index + 1}.webp`}
                                alt={""}
                                width={200}
                                height={200}
                                className={"h-[1.15rem] w-[2.0486rem]"}
                            />

                            <div
                                className={"absolute bottom-0 left-0 right-0 top-0 py-[0.1389rem]"}
                            >
                                <div
                                    className={clsx(
                                        "text-center text-[transparent] " +
                                            " bg-gradient-to-r bg-clip-text",
                                        colors[index + (1 % recharge?.condition?.length)]
                                    )}
                                >
                                    <p className={"text-[0.14rem] font-bold"}>Bônus de depósito</p>
                                    <p className={"text-[0.25rem] font-black"}>{item.reward}%</p>
                                </div>
                                <div
                                    className={
                                        "absolute bottom-[0.0347rem] left-0 right-0 h-[0.2778rem]" +
                                        " text-center text-[0.2rem] leading-[0.2778rem]"
                                    }
                                >
                                    {index + 1}
                                    {text[index + 1]}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={"relative flex w-[100%] justify-center"}>
                <div
                    style={{
                        background: "url(/recharge/button.webp)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%",
                    }}
                    onClick={receiveHandler}
                    className={
                        "flex h-[0.7rem] w-[1.5972rem] items-center justify-center" +
                        " text-[0.1528rem] font-bold text-[#fff]"
                    }
                >
                    <span> {t("rechargeButton")}</span>
                </div>
            </div>
        </div>
    );
};
const UserRecharge = forwardRef<ModalRefProps, Props>(function UserRecharge(props, ref) {
    const [visible, setVisible] = useState(false);

    const recharges = useRef<any>();
    const activeIndex = useRef<number>(0);

    useImperativeHandle(ref, () => {
        return {
            onClose: () => setVisible(false),
            onOpen: (source: any, index?: number) => {
                recharges.current = source;
                if (index !== null && index !== undefined) {
                    activeIndex.current = index;
                }
                setVisible(true);
            },
        };
    });
    return (
        <Mask visible={visible} onMaskClick={() => setVisible(false)}>
            <RechargeContent
                onCancel={() => setVisible(false)}
                recharge={recharges.current?.[activeIndex.current]}
            />
        </Mask>
    );
});

export default memo(UserRecharge);
